/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-26 14:27:27                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 14:47:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * TimeTypeOptionSelectDetails: TimeType detailed options
*/

/* Imports */
import { t } from "i18next";
import { Typography } from "@material-tailwind/react";
import { components } from "react-select";
/***/

/**
* TimeTypeOptionSelectDetails: TimeType detailed options
* Used to display technician details in the technician select component.
* @param value - option value
* @param label - option label
*/
export default function TimeTypeOptionSelectDetails(props: any) {
  return (
    <components.Option {...props}>
      {props.detailed ?
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <Typography variant="small"
                        className="text-gray-900">
              {props.label}
            </Typography>

            <Typography variant="small"
                        className="text-gray-900">
              {t("common:sampleHoursKm")}
            </Typography>
          </div>

          <Typography variant="small"
                      className="text-gray-500">
            {t("common:sampleUpdatedAgo")}
          </Typography>
        </div>
      : <Typography variant="small">{props.label}</Typography>}
    </components.Option>
  );
}
/***/
